<style scoped="scoped" lang="scss"></style>
<style>
.el-select .el-input {
  width: 90px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/customer/auth/user/page" getKey="rows" :columns="columns" @afterGet="afterGet">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yonghuzhanghao')">
            <el-input v-model="yt.conditions.username"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yonghumingcheng')">
            <el-input v-model="yt.conditions.nickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :idsPath.sync="yt.conditions.orgId" :ids.sync="yt.conditions.selecteOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gonghao')">
            <el-input v-model="yt.conditions.jobNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')">
            <el-select v-model="yt.conditions.enabled">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_system_auth_user_create')" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #suoshuzuzhi="scope">
        <span>{{ scope.row.org.name }}</span>
      </template>
      <template #shifoubangdingzhiyuan="scope">
        <span>{{ scope.row.empRelatedFlag ? $t('shi') : $t('fou') }}</span>
      </template>
      <!-- 自定义某个字段 -->
      <template #juese="scope">
        <!-- 角色 -->
        <template>
          <span>{{ scope.row.roles | getRoleText }}</span>
        </template>
      </template>
      <!-- 用户账号 -->
      <!-- 	<template #yonghuzhanghao="scope">
				<template>
					<span>{{store.state.customer.code}}_{{scope.row.username}}</span>
				</template>
			</template> -->
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_system_auth_user_update')" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-popconfirm :title="$t('quedingchongzhimima?chongzhihoumima') + ' : ' + pwdFormat" :confirm-button-text="$t('chongzhi')" @confirm="resetSecret(scope.row)">
              <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_system_auth_user_resetPwd')" slot="reference">{{ $t('chongzhimima') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('auth_user_bind_ic_card')" @click="yt.showEditDialog('bangicka', scope.row)">{{ $t('bangicka') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('auth_user_unbind_ic_card')" @click="unbindIcCommon(scope.row)">{{ $t('jiebangicka') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('auth_user_bind_ic_card_common')" @click="bindIC(scope.row)">{{ $t('bangicka') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('auth_user_unbind_ic_card_common')" @click="unbindIC(scope.row)">{{ $t('jiebangicka') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yonghuzhanghao')" required>
            <el-input style="width: 100px;" :placeholder="$t('qingshuruneirong')" v-model="yt.editObj.username">
              <template slot="prepend"
                >{{ store.state.customer.code }}_</template
              >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('yonghumingcheng')" required>
            <el-input v-model="yt.editObj.nickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')" required>
            <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shoujihaoma')">
            <el-input v-model="yt.editObj.mobile"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Email')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('juese')">
            <yi_data_select :type="'customerRole'" :ids.sync="yt.editObj.roleIds" multiple></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gonghao')">
            <el-input v-model="yt.editObj.jobNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/customer/auth/user/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yonghuzhanghao')" class="noborder" required>
            <!-- <span>{{store.state.customer.code}}_{{yt.editObj.username}}</span> -->
            <el-input v-model="yt.editObj.username" disabled=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('yonghumingcheng')" required>
            <el-input v-model="yt.editObj.nickname" :disabled="yt.editObj.empRelatedFlag"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')" required>
            <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId" :disabled="yt.editObj.empRelatedFlag"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shoujihaoma')">
            <el-input v-model="yt.editObj.mobile" :disabled="yt.editObj.empRelatedFlag"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Email')">
            <el-input v-model="yt.editObj.email" :disabled="yt.editObj.empRelatedFlag"></el-input>
          </el-form-item>
          <el-form-item :label="$t('juese')">
            <yi_data_select :type="'customerRole'" :ids.sync="yt.editObj.roleIds" multiple></yi_data_select>
            <!-- <el-select filterable :clearable="true" v-model="yt.editObj.roleIds" multiple collapse-tags>
							<el-option v-for="(item, index) in rolesList" :key="index" :label="item.name"
								:value="item.id"></el-option>
						</el-select> -->
          </el-form-item>
          <el-form-item :label="$t('gonghao')">
            <el-input v-model="yt.editObj.jobNo" :disabled="yt.editObj.empRelatedFlag"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="unbindEmployee(yt.editObj.id)" v-if="yt.editObj.empRelatedFlag">{{ $t('jiebangrenyuan') }}</el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/customer/auth/user/update')" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 绑定ic卡 -->
      <template v-if="yt.editObj.action == 'bangicka'">
        <div style="width: 100%;height: 120px;display: flex;justify-content: center;align-items: center;font-weight: bold;font-size: 28px;">{{ $t('dengdaishuaka') }}...</div>
        <Yi_card_reader @cardReaded="bindIcCommon"></Yi_card_reader>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导入excel -->
    <import_excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import Yi_card_reader from '@/common/yi_card_reader/yi_card_reader.vue';
import import_excel from '@@/pages/web/system/user/import_excel';
import XLSX from 'xlsx';
export default {
  name: 'web_system_user_list',
  components: {
    import_excel,
    Yi_card_reader
  },
  data() {
    return {
      pwdFormat: '123456',
      show: false,
      list: [],
      rolesList: [],
      exportLoading: false,
      columns: [
        {
          label: 'yonghuzhanghao',
          prop: 'username'
          // type: 'slot',
        },
        {
          label: 'yonghumingcheng',
          prop: 'nickname'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org',
          type: 'slot'
        },
        {
          label: 'shoujihaoma',
          prop: 'mobile'
        },
        {
          label: 'shifoubangdingzhiyuan',
          prop: 'empRelatedFlag',
          type: 'slot'
        },
        {
          label: 'Email',
          prop: 'email'
        },
        {
          label: 'juese',
          type: 'slot',
          prop: 'roles'
        },
        {
          label: 'gonghao',
          prop: 'jobNo'
        },
        {
          label: 'shifouqiyong',
          prop: 'enabled',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = '/web/system/auth/user/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'nickname';
      this.yt.get(1);
      this.getPwdFormat();
      this.getRolesList();
      this.utils.event_hub.$on('SYSTEM_USER_REFRESH', () => {
        this.yt.get();
      });
    }, 300);
  },
  filters: {
    getRoleText(value) {
      return value
        .map(item => {
          return item.name;
        })
        .join(',');
    }
  },
  methods: {
    unbindEmployee(id) {
      this.http
        .get('/web/employee/unbindEmployee', { params: { id: id } })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },

    getPwdFormat() {
      this.http
        .get('/web/customer/auth/user/resetPwdFormat', {
          params: {}
        })
        .then(res => {
          this.pwdFormat = res.data;
        });
    },
    afterGet() {
      this.http
        .get('/web/customer/auth/role/list', {
          params: {}
        })
        .then(res => {
          this.store.commit('SET_CUSTOMER_ROLES', res.data);
        });
    },
    // 重置
    clear() {
      this.yt.get(1);
    },
    async getRolesList() {
      let response = await this.http.get('/web/customer/auth/role/page', {
        params: {
          pageNum: 1,
          pageSize: 10
        }
      });
      this.rolesList = response.data.rows;
    },
    resetSecret(editObj) {
      this.http
        .post('/web/customer/auth/user/resetPwd', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    bindIcCommon(no) {
      let params = this.yt.editObj;
      params.no = no;
      params.userId = params.id;
      this.http
        .post('/web/auth/bindIcCardCommon', params)
        .then(res => {
          this.utils.successMessage(this.$t('bangdingchenggong'));
          this.yt.isShowEditDialog = false;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    unbindIcCommon(user) {
      let params = {};
      params.userId = user.id;
      this.http
        .post('/web/auth/unbindIcCardCommon', params)
        .then(res => {
          this.utils.successMessage(this.$t('jiebangchenggong'));
          this.yt.isShowEditDialog = false;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },

    bindIC(user) {
      //初始化卡机
      var wsr = wsrProxy;
      // 初始化 wsrProxy
      wsr.init();
      //打开刷卡端口
      let port = 0; //端口
      let block = 1; //扇区1
      //let key = "AA20210108"; // 卡密码
      let key = 'FFFFFFFFFFFF';
      let keytype = 0; //密码A
      //打开端口
      let ret = wsr.ws_openPort(port);
      let card = {
        cardno: '',
        uid: '',
        len: 0
      }; // 卡号为 字符串 string

      if (ret < 0) {
        alert(this.$t('dakaiICkaduankoushibai'));
        return;
      }

      ret = wsr.ws_getCardNo_String(port, card);
      if (ret < 0) {
        alert(this.$t('dukahaocuowu'));
        return;
      }

      this.http
        .post('/web/auth/bindIcCard', { userName: user.username, no: card.cardno })
        .then(res => {
          if (res.data == null) {
            alert(this.$t('bangdingchenggong'));
          } else {
            ret = wsr.ws_verifyKey(port, key, keytype, block);
            //验证密码失败，就先加载原始密码然后修改密码，然后再次验证
            if (ret < 0) {
              alert(this.$t('mimacuowu'));
              return;
            }

            ret = wsr.ws_writeBlock(port, 4, res.data.uid);
            if (ret < 0) {
              alert(this.$t('xieruidcuowu'));
              return;
            }
            ret = wsr.ws_writeBlock(port, 5, res.data.secret);
            if (ret < 0) {
              alert(this.$t('xierumimacuowu'));
              return;
            }
            alert(this.$t('bangdingchenggong'));
          }
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    unbindIC(user) {
      this.http
        .post('/web/auth/unbindIcCard', { username: user.username })
        .then(res => {
          this.utils.successMessage(this.$t('jiebangchenggong'));
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    exportExcel() {
      this.exportLoading = true;
      //查询表格
      this.http
        .get('/web/customer/auth/user/page?pageNum=1&pageSize=99999', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = this.columns.map(i => {
            if (i.label != 'caozuo') {
              return this.$t(i.label);
            }
          });
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = [];
            dataArr[tableFirst.indexOf(this.$t('yonghuzhanghao'))] = listData[i].username ? listData[i].username : '';
            dataArr[tableFirst.indexOf(this.$t('yonghumingcheng'))] = listData[i].nickname ? listData[i].nickname : '';
            dataArr[tableFirst.indexOf(this.$t('suoshuzuzhi'))] = listData[i].org ? (listData[i].org.name ? listData[i].org.name : '') : '';
            dataArr[tableFirst.indexOf(this.$t('shoujihaoma'))] = listData[i]['mobile'] ? listData[i]['mobile'] : '';
            dataArr[tableFirst.indexOf(this.$t('shifoubangdingzhiyuan'))] = listData[i].empRelatedFlag ? this.$t(this.store.state.dictJson['SYSTEM_YES_NO'][1]) : this.$t(this.store.state.dictJson['SYSTEM_YES_NO'][0]);
            dataArr[tableFirst.indexOf(this.$t('Email'))] = listData[i].email ? listData[i].email : '';
            dataArr[tableFirst.indexOf(this.$t('juese'))] = listData[i].roles
              .map(item => {
                return item.name;
              })
              .join(',');
            dataArr[tableFirst.indexOf(this.$t('gonghao'))] = listData[i].jobNo ? listData[i].jobNo : '';
            dataArr[tableFirst.indexOf(this.$t('shifouqiyong'))] = listData[i].enabled ? this.$t(this.store.state.dictJson['SYSTEM_YES_NO']['1']) : this.$t(this.store.state.dictJson['SYSTEM_YES_NO']['0']);
            tableData.push(dataArr);
          }
          let worksheet = XLSX.utils.aoa_to_sheet(tableData);
          let workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `${this.$t('web_system_user')}_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    }
  }
};
</script>
